import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export const LocationIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16.515" height="16.515" viewBox="0 0 16.515 16.515">
        <path
          d="M0 5.853a1.4 1.4 0 0 0 .983 1.332L6.94 9.056a.078.078 0 0 1 .06.062l1.871 5.956a1.4 1.4 0 0 0 1.332.986h.011a1.4 1.4 0 0 0 1.336-.964l4.376-13.185A1.408 1.408 0 0 0 14.147.132L.962 4.506A1.4 1.4 0 0 0 0 5.853zm1.378-.1L14.56 1.378a.095.095 0 0 1 .12.12l-4.374 13.185a.086.086 0 0 1-.09.065.086.086 0 0 1-.09-.066L8.254 8.725a1.39 1.39 0 0 0-.921-.925L1.377 5.933a.095.095 0 0 1 0-.181z"
          transform="translate(.252 .205)"
          stroke="currentColor"
          fill="currentColor"
          strokeWidth=".5px"
        />
      </svg>
    </SvgIcon>
  );
});
